import CurrentRecommendation from "./current-recommendation";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-[22px] font-normal text-[#1E2F65]">
          Recommendations
        </h3>
        <CurrentRecommendation />
      </div>
    </div>
  );
};

export default Offers;
